import type { Root } from 'mdast';
import type { VFile } from 'vfile';
import rehypeRaw from 'rehype-raw';
import rehypeStringify from 'rehype-stringify';
import remarkDirective from 'remark-directive';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';

export type IRemarkPlugin = () => (tree: Root, file: VFile) => void;

export const markdownToHtml = (
  markdown: string,
  plugins?: Array<IRemarkPlugin>,
  options?: { allowDangerousHtml?: boolean },
): Promise<string> => {
  const processor = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkDirective)
    .use(plugins ?? [])
    .use(remarkRehype, { allowDangerousHtml: options?.allowDangerousHtml })
    .use(rehypeRaw)
    .use(rehypeStringify, { allowDangerousHtml: options?.allowDangerousHtml });

  const processedMarkdown = markdown.replaceAll('\\<', '<');

  return processor.process(processedMarkdown).then((file) => {
    const html = String(file);

    return html;
  });
};
